module.exports = __webpack_public_path__ + "img/icon-edit-1.3bf109ea.svg";